import { ColTypeDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { CutOffResponse } from 'apiConnector/secondary-market/cp-order/model';
import { useSPIntl } from 'hooks/useIntl';
import { isEqual } from 'lodash-es';
import { useMemo } from 'react';
import { formatDatetimeWithTimezone } from 'routes/secondary-market-batch/grid/utils/format-datetime-with-timezone';
import { RowData } from 'state/workspaces/secondary-market/batch/model';

export function useDatetimeWithTimezoneColumnType(): ColTypeDef<RowData, RowData[keyof RowData]> {
  const { formatTime } = useSPIntl();

  return useMemo(
    () => ({
      equals: isEqual,
      filter: 'agSetColumnFilter',
      filterParams: {
        valueFormatter: ({ value }: ValueFormatterParams<RowData>) => {
          const cutOff = value as CutOffResponse | undefined;
          return cutOff?.nextCutOff;
        },
      },
      filterValueGetter: ({ getValue, colDef }: ValueGetterParams<RowData>) => {
        const cutOff = colDef.field ? (getValue(colDef.field) as CutOffResponse | undefined) : undefined;
        return cutOff ? formatDatetimeWithTimezone(cutOff, formatTime) : '';
      },
      valueFormatter: ({ value }: ValueFormatterParams<RowData>) => {
        const cutOff = value as CutOffResponse | undefined;
        return formatDatetimeWithTimezone(cutOff, formatTime);
      },
    }),
    [formatTime],
  );
}
